import { BadgeProps } from 'antd';

import { EActionReportStatuses } from 'entities/Report';
import { i18n } from 'i18n';

type TReportStatuses = Record<EActionReportStatuses, { name: string; status: BadgeProps['status'] }>;

export const REPORT_STATUSES = (): TReportStatuses => ({
	[EActionReportStatuses.REJECTED]: { name: i18n.t('Отклоненный'), status: 'error' },
	[EActionReportStatuses.PENDING]: { name: i18n.t('Открытый'), status: 'default' },
	[EActionReportStatuses.AWAITING_CONFIRMATION]: {
		name: i18n.t('Подтвержденный: ожидает подтверждения рекламодателя'),
		status: 'success',
	},
	[EActionReportStatuses.AWAITING_PAYMENT]: {
		name: i18n.t('Подтвержденный: ожидает оплаты рекламодателя'),
		status: 'success',
	},
	[EActionReportStatuses.READY_FOR_WITHDRAWAL]: { name: i18n.t('Подтвержденный: готов к выводу'), status: 'success' },
	[EActionReportStatuses.PAID]: { name: i18n.t('Подтвержденный: выплачен'), status: 'success' },
});

export const REPORT_STATUS_OPTIONS = () =>
	Object.keys(REPORT_STATUSES()).map((key) => ({
		label: REPORT_STATUSES()[key as keyof ReturnType<typeof REPORT_STATUSES>].name,
		value: key,
	}));
